var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCaroButton = function SvgCaroButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    transform: "rotate(-90 36 36)",
    fill: "#fff",
    stroke: "#EDF1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 36h-21M38.998 28.498L46.5 36l-7.502 7.502",
    stroke: "#170426",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCaroButton;